module.exports = __webpack_public_path__ + "img/portifolio_hospitalar.63e1f93a.jpg";